<div class="modal-header" data-cy="validate-signature-modal">
	<h4 class="modal-title w-100 text-center fw-semibold">
		<strong>{{ "LOGIN.LABEL.SIGNATURE_ERROR_TITLE" | translate }}</strong>
	</h4>

	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="hideModal()"
	>
		<span aria-hidden="true" class="visually-hidden">&times;</span>
	</button>
</div>

<div class="modal-body d-flex flex-column align-items-center modal-body-custom">
	<img
		src="assets/icons/modal/warning.svg"
		[alt]="'LOGIN.LABEL.SIGNATURE_ERROR_TITLE' | translate"
		class="warning-icon mb-4"
	/>
	<span class="text-center text-muted mb-0"> {{ modalMsg }} </span>
</div>

<div class="modal-footer">
	<button
		*ngIf="!modalLink"
		(click)="hideModal()"
		type="button"
		class="btn btn-primary me-0"
	>
		{{ "LOGIN.LABEL.SIGNATURE_ERROR_BUTTON" | translate }}
	</button>
	<div *ngIf="!!modalLink">
		<a
			[href]="modalLink"
			class="btn btn-primary"
			target="_blank"
			rel="noopener noreferrer"
			>{{ modalLinkText }}</a
		>
	</div>
</div>
